<template>
	<div v-bind:class="['patient', {
		corrected: newPatient || existingPatient || sameSchedulePatient || providerSelected,
		error: (invalidEmail && !skipPatient) || invalidProvider || invalidPatient || unconfirmedPatient
	}]">
		<!-- <div class="action" v-if="confirm">
			<el-button v-if="invalidEmail"
				v-bind:type="skipPatient ? 'primary' : 'danger'" size="small"
				@click="toggleSkipPatient">
				<b>{{ skipPatient ? 'Add Patient Data' : 'Skip Patient' }}</b>
			</el-button>
		</div> -->

		<div class="account">
			<span class="name">
				<strong>{{ index }}. {{ patient.data.name }}</strong>
				<div v-if="!confirm && patient.data.email" class="extra-info">
					{{ patientProviderNames }}
					<span class="info" v-if="patient.data.id">
						&bull;&nbsp;
						Enrolled {{ formatDate(patient.data.created, true, true) }}
					</span>
				</div>
				<!-- <div v-if="providedValidEmail" class="valid-info">
					Patient will now be enrolled
				</div> -->
				<template v-if="patient.data.phone || patient.data.email">
					<br>
					<small> 
						<template v-if="patient.data.email"> {{ patient.data.email }}</template>
						{{ patient.data.phone && patient.data.email ?  ',' : ''}}
						<template v-if="patient.data.phone">{{ patient.data.phone }}</template>
					</small>
				</template>
			</span>

			<template v-if="patient.invalidProvider">
				<ol class="events" :class="patient.data.event.length > 1 ? 'multiple' : 'single'" >
					<li class="event" v-for="(event, index) in patient.data.event"
						:key="index">
						<el-select v-model="event.provider" size="small" @change="updateProfiles">
							<el-option v-for="provider in getProviderList"
								:key="provider.provider"
								:label="provider.name"
								:value="provider.provider"
								>
							</el-option>
						</el-select>
					</li>
					
				</ol>
				
			</template>

			<template v-if="! skipPatient && confirm">
				<div class="email" v-if="invalidEmail || confirm">
					<el-input v-model="email"
						placeholder="Enter Email to Enroll"
						size="small"
						autocomplete="false"
						style="width:230px;">
					</el-input>
				</div>
			</template>
		</div>

		<ImportData
			v-if="! skipPatient"
			:patient="patient"
			:column="column"
			:highlight="['name', 'email', 'phone']">
		</ImportData>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Vue from 'vue'

import validEmail from '@/module/util/valid-email'
import ImportPatientRow from '.'

export default {
	name: 'import-patient-email-row',
	extends: ImportPatientRow,

	data() {
		return {
			email: this.patient.data.email || '',
			providerSelected: false,
		}
	},

	watch: {
		email(email) {
			Vue.set(this.patient, 'corrected', validEmail(email))
			if(validEmail(email)) {
				Vue.set(this.patient.data, 'email', email)
				Vue.set(this.patient, 'validated', true)
			}
		}
	},

	methods: {
		/**
		 * Updates profiles in all `patient.data.event` on select on any provider
		 */
		updateProfiles() {
			// If event array exists
			if(this.patient.data.event && Array.isArray(this.patient.data.event))

				this.patient.data.event.forEach((event) => {

					// Setting for only where `provider` is set but `profile` not yet set
					if(event.provider) {
						
						// Gets current provider of the event from the list
						this.providerSelected = true
						const currentProvider =  this.getProviderList.find((provider) => provider.provider == event.provider)
						// Set profile if the profile array has only one profile
						if(currentProvider.profile && Array.isArray(currentProvider.profile)) {
							if(currentProvider.profile.length == 1)
								event.profile = [currentProvider.profile[0].id]
							else
								event.profile = null
						}
					}
				})
		}
	},

	computed: {
		...mapGetters('provider', [ 'getProviderNameById' ]),
		invalidEmail() {
			return ! this.patient.data || ! validEmail(this.patient.data.email)
		},
		providedValidEmail() {
			return validEmail(this.email)
		},
		invalidProvider() {
			return this.patient.invalidProvider
		},
		invalidPatient() {
			return this.patient.invalid
		},
		unconfirmedPatient() {
			return this.patient.confirmed != null
		},
		newPatient() {
			return (! this.patient.existing && (! this.patient.invalid || this.patient.corrected) && !(Array.isArray(this.patient.data.event) && this.patient.data.event.some((event) => !event.provider)))
		},
		existingPatient() {
			return !(Array.isArray(this.patient.data.event) && this.patient.data.event.some((event) => !event.provider)) && this.patient.existing
		},
		sameSchedulePatient() {
			return this.patient.sameSchedule
		},
	},
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>
